// Angular
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PatientsService } from '../../../../../../patients/patients.service';
import { Router } from '@angular/router';
import { ShareService } from '../../../../../../shared/service/share.service';
import { StorageService } from '../../../../../../Service/storage.service';
import { AuthService } from '../../../../../../core/auth/auth.service';

@Component({
    selector: 'kt-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['notification.component.scss'],
    standalone: false
})
export class NotificationComponent implements OnInit {

  // Show dot on top of the icon
  @Input() dot: boolean;

  // Show pulse on icon
  @Input() pulse: boolean;

  @Input() pulseLight: boolean;

  // Set icon class name
  @Input() icon: string = 'flaticon2-bell-alarm-symbol';
  @Input() iconType: '' | 'success';

  // Set true to icon as SVG or false as icon class
  @Input() useSVG: boolean;

  // Set bg image path
  @Input() bgImage: string;

  // Set skin color, default to light
  @Input() skin: 'light' | 'dark' = 'light';

  @Input() type: 'brand' | 'success' = 'success';

  /**
   * Component constructor
   *
   * @param sanitizer: DomSanitizer
   */

  public reminderList = [];
  userRole: string;
  reminderCount: any;

  constructor(public patientService: PatientsService,
    private translate: TranslateService, private router: Router,
    public shareservice: ShareService, private readonly storageService: StorageService,
    private readonly authService: AuthService) {
    // this.getAllReminder();
    // this.translate.addLangs(environment?.languages);
    this.translate.use(this.storageService.getItem('language') || 'en');
    this.shareservice.reminderData$.subscribe(newData => {
      this.reminderCount = newData;
    });
  }

  backGroundStyle(): string {
    if (!this.bgImage) {
      return 'none';
    }

    return 'url(' + this.bgImage + ')';
  }

  ngOnInit(): void {
    if (!this.authService.isInOnboarding()) {
      this.getAllReminder();
    }
  }

  getAllReminder() {
    this.patientService.getReminderByuserID(this.storageService.getItem('userId')).subscribe(res => {
      if (res['Success']) {
        this.reminderList = res['Data'];
        const filteredReminderList = res['Data'].filter((value) => {
          return value.TaskStatus == 0;
        })
        this.reminderCount = filteredReminderList?.length;
      } else {
        this.reminderList = [];
        this.reminderCount = 0;
      }
    });
  }

  navigate() {
    this.userRole = this.storageService.getItem('AspNetRole')
    if (this.userRole == "Pharmacies") {
      this.router.navigate(['Dashboard'])
    } else {
      this.router.navigate(['Setup/To-Do'])
    }
  }
}
